// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "SingleName" + "." + "c2a4eb21" + ".chunk.css";
};